import { environment } from '../environments/environment';


/** Versión tomada del bundle / package.json vía `environment` */
export const APP_VERSION = environment.version;

/** Duración por defecto para snackbars (ms) */
export const SNACKBAR_DURATION = 20000;

/** Ruta a iconos/imagenes usados en la app (usar constantes para mantener coherencia) */
export const EMPTY_ICON_PATH = '/folder.svg';

export const API_URL = environment.apiUrl;

export const IS_PROD = environment.production;

/** Agregar aquí más constantes específicas según crezca la app */

export default {
    APP_VERSION,
    SNACKBAR_DURATION,
    EMPTY_ICON_PATH,
    API_URL,
    IS_PROD
};
